import { render } from "./DexTableHeader.vue?vue&type=template&id=7f39b8aa"
import script from "./DexTableHeader.vue?vue&type=script&lang=js"
export * from "./DexTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__